import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { WorkCalculationitem, WorkItemsForProjectDto } from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-project-items-for-customers',
  templateUrl: './ax-project-items-for-customers.component.html',
  styleUrls: ['./ax-project-items-for-customers.component.scss'],
})
export class AxProjectItemsForCustomersComponent implements OnInit {
  @Input() items: WorkItemsForProjectDto;
  @Output() openItemDetailsForCalculationitem: EventEmitter<WorkCalculationitem> = new EventEmitter<WorkCalculationitem>();
  public accordionStates: any = {};

  constructor() {
  }

  ngOnInit() {
  }
}
